import * as Application from 'expo-application';
import * as Device from 'expo-device';
import { Platform } from 'react-native';

export interface CheckCaptureDeviceTracking {
  app_bundle_id: string;
  app_version: string;
  device_model: string;
  device_system_name: string;
  device_system_version: string;
  vendor: string;
}

export const getCheckCaptureDeviceTracking =
  (): CheckCaptureDeviceTracking => ({
    app_bundle_id: Application.applicationId ?? '',
    app_version: Application.nativeApplicationVersion ?? '',
    device_model: Device.modelName ?? '',
    device_system_name: Platform.OS,
    device_system_version: Device.osVersion ?? '',
    vendor: 'Pepper',
  });
